import * as l from '../lib/littlejs.esm';
class Globals {
}
Globals.rex = null;
Globals.chip = null;
Globals.player = null;
Globals.lastCheckpoint = l.vec2(0, 0);
Globals.entitiesData = [];
Globals.keys = 0;
Globals.rexHasKey = false;
Globals.levelStartTime = 0;
Globals.levelCompletionTime = 0;
Globals.levelCompleted = false;
Globals.gameState = 'menu';
export default Globals;
